/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// End of auto-generated comments

/*
  IMPORTANT - How react-rails is used with the asset pipeline and Webpacker simultaneously:

  1. react must be imported globally on the `window` in app/assets/javascripts/application.js via the react-rails gem
  2. react_ujs must be imported below as a node_module via webpack (which also attaches itself to `window`)
  3. react_ujs must be told about our webpacked components first in app/javascript/components so it can reference them later
  4. The remaining non-webpacked components will be available on the `window` as normal via the asset pipeline
  5. A rails view renders a `<%= react_component 'FooBar' %>` helper to the DOM
  6. On load, react_ujs will try to find and mount that component's exported class name from our webpacked components
  7. If it does not find one, it will fall back to `window` and mount our asset-pipeline component

  NOTE: we cannot have duplicate component class names until everything is migrated to webpacker

  https://github.com/reactjs/react-rails/blob/f8148d57a6d96b27bddfaef9f9bf26e233b27bd6/react_ujs/src/getConstructor/fromRequireContextWithGlobalFallback.js#L7
*/

var componentRequireContext = require.context('components', true)
var ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)

document.addEventListener('DOMContentLoaded', () => {
  // Add no-outline class on initial load
  document.body.classList.add('no-outline')

  // Add no-outline class on clicks
  document.body.addEventListener('click', () => {
    document.body.classList.add('no-outline')
  })

  // Remove no-outline class on keydown to show accessibility styles
  document.body.addEventListener('keydown', () => {
    document.body.classList.remove('no-outline')
  })

  // Add event listener for data-stop-propagation attribute
  document.querySelectorAll('[data-stop-propagation]').forEach((element) => {
    element.addEventListener('click', (event) => event.stopPropagation())
    element.addEventListener('keydown', (event) => event.stopPropagation())
  })

  // Initialize react-axe in development
  if (process.env.NODE_ENV !== 'production' && process.env.ENABLE_AXE) {
    var axe = require('react-axe')
    axe(React, ReactDOM, 10000)
  }
})
